import script from "./CreatePVMemoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CreatePVMemoPage.vue?vue&type=script&setup=true&lang=js"

import "./CreatePVMemoPage.vue?vue&type=style&index=0&id=230d269c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-230d269c"]])

export default __exports__